export default "__VITE_ASSET__QxlkLgHC__"